// Waiver gating for the Manage Team Attendance list — shared by web + mobile so
// both platforms lock the same rows.

export interface WaiverPlayer {
  is_signed_waiver?: boolean | null
}

/**
 * Game-level gate: unsigned-waiver rows are only locked when the game shows
 * waivers (the org's "Request Waiver" → `show_waiver` / `should_show_waiver` on
 * the game) AND its schedule settings require a signed one
 * (`settings.game.require_waiver_signature`). Either off → no row is locked.
 */
export const isWaiverEnforced = (
  shouldShowWaiver: boolean | null | undefined,
  requireWaiverSignature: boolean | null | undefined
): boolean => !!shouldShowWaiver && !!requireWaiverSignature

/**
 * Row-level lock: a roster / roster-spare player who hasn't signed (a missing
 * `is_signed_waiver` counts as unsigned) on a waiver-enforced game. Eligible
 * Game Spares aren't on the roster, so the gate never applies to them.
 */
export const isWaiverLocked = (
  player: WaiverPlayer | null | undefined,
  waiverEnforced: boolean,
  isSpareCandidate: boolean
): boolean => !isSpareCandidate && waiverEnforced && !player?.is_signed_waiver
